/* @ngInject */
const sale = (
  saleAsk,
  saleData,
  saleFormat,
  saleGo,
  saleLocal,
  saleMetadata,
  saleRequest,
  saleResource,
  saleLabels
) => {
  const self = {}

  self.ask = saleAsk
  self.data = saleData
  self.format = saleFormat
  self.go = saleGo
  self.local = saleLocal
  self.metadata = saleMetadata
  self.request = saleRequest
  self.resource = saleResource
  self.labels = saleLabels

  self.new = () => {
    return {
      id: null,
      number: null,
      owner: null,
      date: null,
      axletreeDefaultWeight: 1300,
      axletrees: [],
      pieces: [],
      steriles: [],
    }
  }

  self.search = {
    id: null,
    number: null,
    numberOperator: '=',
    ownerId: null,
    dateBegin: null,
    dateEnd: null,
  }

  return self
}
export default sale



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sale/services/sale.service.js